export const KeskkonnaMuutujad = {
  kasutajaToken: 'user_token',
  kasutajaTokenKood: 'access_token',
  kuupaevFormaat: 'DD.MM.YYYY',
  kuupaevAjagaFormaat: 'DD.MM.YYYY [kell] HH:mm',
  kuupaevAjaFormaat: 'HH:mm',
}